// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFoundPage_notFoundContainer__mry2b","homeButton":"NotFoundPage_homeButton__kKU48"};